import {
  ChangePlanApi,
  ChangePlanDetailsRequest,
  ChangePlanDetailsResult,
  DynamicChangePlanDetailsRequest,
} from './ChangePlanTypes';
import { PaymentCycle_BIMap } from '../../services/BiLogger/BiLoggerTypes';
import { AppStore } from '../../stores/App.store';
import Api from 'services/Api/Api';

const changePlanClassicApi = {
  switchAndRefund: Api.changePlanSwitchAndRefund,
  switchAndExtend: Api.changePlanSwitchAndExtend,
  switchInGracePeriod: Api.changePlanSwitchInGracePeriod,
};

const changePlanDynamicApi = {
  switchAndRefund: Api.changePlanDyanmicSwitchAndRefund,
  switchAndExtend: Api.changePlanDynamicSwitchAndExtend,
  switchInGracePeriod: Api.changePlanDynamicSwitchInGracePeriod,
};

export const getApiParams = (
  isDynamicOffering: boolean,
  appStore: AppStore,
): {
  switchParams: DynamicChangePlanDetailsRequest | ChangePlanDetailsRequest;
  api: ChangePlanApi;
} => {
  const {
    currentProduct,
    appContext: { currentPlanDetails },
  } = appStore;
  const { userPackageGuid } = currentPlanDetails!;

  return isDynamicOffering
    ? {
        switchParams: {
          targetProductId: currentProduct?.guid ?? '',
          subscriptionId: userPackageGuid,
        } as DynamicChangePlanDetailsRequest,
        api: changePlanDynamicApi,
      }
    : {
        switchParams: {
          targetProductId: currentProduct.id,
          userPackageGuid,
        } as ChangePlanDetailsRequest,
        api: changePlanClassicApi,
      };
};

export const getBiParams = (
  biChangePlanDetails: ChangePlanDetailsResult,
  appStore: AppStore,
) => {
  const {
    currentProduct,
    appContext: { currentPlanDetails },
  } = appStore;
  const { planId, userPackageGuid } = currentPlanDetails!;
  const { changePlanType, destinationProductDetails } = biChangePlanDetails;
  const biCurrentPlanDetails = biChangePlanDetails.currentPlanDetails;
  return {
    changeType: changePlanType,
    productId: planId,
    cycle: PaymentCycle_BIMap[biCurrentPlanDetails.paymentCycle],
    newCycle: PaymentCycle_BIMap[destinationProductDetails.paymentCycle],
    newProductId: currentProduct.id,
    packageId: userPackageGuid,
  };
};
